import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToastMessageComponent {

constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }


}
